// 撤回承运商历史

import request from '@/utils/http';

// 查询列表数据
const queryWithdrawReport = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/queryWithdrawReport`,
        method: 'get',
        params: data
    });
};

export default {
    queryWithdrawReport
};